// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","809":"transfer"}[chunkId] + "." + {"443":"c4dff15e","809":"851d725b"}[chunkId] + ".js";
};